import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersServices } from '../../../kitchen/services';
import { OrdersCoServices } from '../../../orders/services';
import { NativeStorage } from '@ionic-native/native-storage';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kitchen-sections',
  templateUrl: 'kitchen-sections.html',
})
export class KitchenSectionsPage {
  title: any;
  tags_show: any = [];
  classActive: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public ordersServices: OrdersServices,
    public ordersCoServices: OrdersCoServices,
    private nativeStorage: NativeStorage,
    public translate: TranslateService) {
    this.title = this.navParams.get('title');
    if(this.ordersServices.change_language){
      this.ordersServices.setSelectShow();
      this.ordersServices.setActiveSections();
      this.ordersServices.change_language = false; 
    }
    
  }

  ionViewWillEnter() {
    this.setClass();
    if(this.ordersCoServices.elements_active_tags.length == 1)
    {
        this.ordersCoServices.chargeElementsActiveTags();
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }

  save() {
    if(this.ordersServices.show_type == "tags" && !this.globals.checkLimitsByLicense('kitchen','categories')){
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else{
      this.viewCtrl.dismiss();
      this.saveNative();
    }
    
  }

  checkSectionAccepted(section) {
    section.active = section.active;

    if (this.translate.instant('general-todos') == section.name) {
      //si la seccion es todos reseteamos la lista select_show
      this.ordersServices.setSelectShow();
      this.ordersServices.setActiveSections();
    } else {
      //si no borramos la secion todos
      this.ordersServices.select_show[0].active = false;
      if (this.ordersServices.active_sections.indexOf(this.translate.instant('general-todos')) >= 0) {
        this.ordersServices.active_sections.splice(this.ordersServices.active_sections.indexOf(this.translate.instant('general-todos')), 1);
      }
      //
      if (section.active) {
        this.ordersServices.active_sections.push(section.name);
      } else {
        this.ordersServices.active_sections.splice(this.ordersServices.active_sections.indexOf(section.name), 1);
      }
    }

    this.changeType('sections');
  }

  checkTagsAccepted(tag) {
    if(this.ordersServices.show_type == "tags" && !this.globals.checkLimitsByLicense('kitchen','categories')){
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else{
      tag.active = tag.active;
      if (tag.active) {
        //si pasa a estar activo guardamos el tag
        this.ordersCoServices.active_tags.push(tag.name);
      } else {
        //si no lo borramos
        this.ordersCoServices.active_tags.splice(this.ordersCoServices.active_tags.indexOf(tag.name), 1);
      }
      if (tag.name == this.translate.instant('general-todos')) {
        //si el tag es TODOS borramos todos los otros tags
        this.ordersCoServices.active_tags = [this.translate.instant('general-todos')];
        this.ordersCoServices.chargeElementsActiveTags();
      } else {
        //si el tag es cualquier otro que no sea todos borramos el tag TODOS
        this.ordersCoServices.elements_active_tags[0].active = false;
        if (this.ordersCoServices.active_tags.indexOf(this.translate.instant('general-todos')) >= 0) {
          this.ordersCoServices.active_tags.splice(this.ordersCoServices.active_tags.indexOf(this.translate.instant('general-todos')), 1);

        }
      }
      this.changeType('tags');
  }
  }

  changeType(type) {
      //sections - tags
      this.ordersServices.show_type = type;
      this.nativeStorage.setItem('show_type_kitchen', this.ordersServices.show_type);
  }

  setClass() {
    if (this.ordersServices.show_type == 'tags') {
      document.getElementById('tags-tab').classList.add('active');
      document.getElementById('tags').classList.add('active');
    } else {
      document.getElementById('sections-tab').classList.add('active');
      document.getElementById('sections').classList.add('active');
    }
  }

  saveNative() {
   this.ordersServices.saveNative();
  }


}



// WEBPACK FOOTER //
// ./src/pages/components/popups/kitchen-sections/kitchen-sections.ts